import React from 'react';
import SvgIcon from './SvgIcon';

const ScenarioCard = props => (
    <SvgIcon viewBox="0 0 114 146" {...props}>
        <g id="New" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" fillOpacity="0.2">
            <g
                id="2-Navigation---Critical-Communications"
                transform="translate(-476.000000, -622.000000)"
                fill="#3777BC"
                fillRule="nonzero"
            >
                <g id="card/card-text-center-2-copy-6" transform="translate(295.000000, 592.000000)">
                    <path
                        d="M275.505721,61.9962455 C274.842092,61.4828784 273.970543,61.3241924 273.168722,61.5707401 C272.3669,61.8172877 271.734811,62.4383194 271.47382,63.235993 C268.850438,70.6169543 264.612036,77.3181482 259.068366,82.8498321 C259.325973,77.648845 259.083078,72.4351221 258.343037,67.2806693 C255.947644,50.9521612 248.423321,38.3532269 236.585741,30.8630855 C235.790726,30.360657 234.785554,30.3305595 233.961937,30.784522 C233.13832,31.2384845 232.62657,32.1046807 232.626114,33.0455577 C232.626114,44.2058683 226.622144,55.4255835 215.29565,65.4933666 C204.900985,74.7320686 180.743133,99.1292669 181.001257,126.083445 C181.181944,145.139397 191.388179,171.561517 217.3529,181.464 C218.357004,170.760846 223.121978,162.867787 227.770797,155.222677 C232.700971,147.115245 237.357533,139.467552 237.791181,128.508701 C237.828497,127.486117 238.465625,126.581997 239.415705,126.203412 C240.365785,125.824827 241.449647,126.043173 242.179294,126.76014 C255.542389,139.803317 262.7105,158.076679 263.526173,181.120487 C282.007872,173.96611 297.309479,157.702172 299.526767,130.890049 C302.118335,99.5244364 294.039045,76.3463232 275.505721,61.9962455 Z"
                        id="scenario"
                    ></path>
                </g>
            </g>
        </g>
    </SvgIcon>
);

ScenarioCard.displayName = 'ScenarioCardIcon';

export default ScenarioCard;
